import { render, staticRenderFns } from "./ActionRejectStateChange.vue?vue&type=template&id=dbb6564c&scoped=true&"
import script from "./ActionRejectStateChange.vue?vue&type=script&lang=js&"
export * from "./ActionRejectStateChange.vue?vue&type=script&lang=js&"
import style0 from "./ActionRejectStateChange.vue?vue&type=style&index=0&id=dbb6564c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbb6564c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VDataTable,VIcon,VRow,VTextarea,VTooltip})
